/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import "./display-gp3r.scss";
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

type DisplayGP3RProps = {
    ready: boolean,
    cartUrl: string,
    cartExpired: boolean,
    productCount: number,
    remainingTimeString: string,
    displayTime: boolean,
    expiresSoon: boolean,
    showLogout: boolean,
    onLogoutClick: () => void,
    onCartClick: () => void,
};

export function DisplayGP3R({ ready, productCount, remainingTimeString, cartExpired, onCartClick, /*onLogoutClick, expiresSoon, displayTime, showLogout*/ }: DisplayGP3RProps) {

    if (!ready)
        return <span></span>;

    let timeLabel;
    let productCountLabel;

    if (productCount > 0) {
        timeLabel = <li><span className="time">{remainingTimeString}</span></li>;
        productCountLabel = <li><div className="product-count">{productCount}</div></li>;
    } else {
        if (cartExpired)
            timeLabel = <li><div className="time elapsed">{tr("cartwidget.timeelapsed")}</div></li>;
        productCountLabel = <li><div className="product-count no-item">0</div></li>;
    }

    // if (this.props.showLogout)
    //     logoutLink =
    //         <a href="#" onClick={onLogoutClick}>
    //             <ul>
    //                 <li><i className="fa fa-user fa-2x"></i></li>
    //                 <li>{tr("cartwidget.logout")}</li>
    //             </ul>
    //         </a>;

    const cartLink = <li><div className="cart-link">{tr("cartwidget.cart")}</div></li>;


    return <div className="display-gp3r">
        <div className="cart-status-control cart-status-control-display1">
            {/* Be careful with what you use here becasue this controle MUST defines its own width according
                        to it's content since the width is sent the the frame owner and then resized accordingly  */}
            <ul>

                <li>
                    {/* TODO: Refactor this as a button */}
                    {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
                    <a onClick={onCartClick} onKeyDown={(e) => { if (e.key === 'Enter') onCartClick(); }} role="button" tabIndex={0} target="_top">
                        <ul>
                            {timeLabel}
                            {productCountLabel}
                            {cartLink}
                        </ul>
                    </a>
                </li>
            </ul>
        </div>
    </div>;
}
